import useSWR from "swr";
import { authApi } from "@/lib/api";

type UserProfile = {
  id: string;
  email: string;
  name: string;
  lastName: string;
};

/**
 * Hook reutilizable para obtener el perfil del usuario autenticado.
 * Usa SWR para cache compartido y deduplicación automática de requests.
 */
export function useUserProfile() {
  const { data, error, isLoading, mutate } = useSWR<UserProfile>(
    "/auth/profile",
    () => authApi.profile(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000, // 1 minuto - cache compartido entre componentes
    }
  );

  return {
    profile: data,
    isLoading,
    isError: error,
    mutate,
  };
}

